export type PurchaseKind = 'PURCHASE_REQUEST' | 'PURCHASE_ORDER' | 'RECEIVING_REPORT' | 'BILL' | 'SUPPLIER_CREDIT';
export type PurchaseStatus = 'DRAFT' | 'PENDING_APPROVAL' | 'APPROVED' | 'POSTED' | 'CLOSED' | 'VOIDED';
export type InputVatClass = 'GOODS' | 'CAPITAL' | 'SERVICES' | 'IMPORTATION' | 'NONE';

export const KIND_LABEL: Record<PurchaseKind, string> = {
  PURCHASE_REQUEST: 'Purchase Request',
  PURCHASE_ORDER: 'Purchase Order',
  RECEIVING_REPORT: 'Receiving Report',
  BILL: 'Bill',
  SUPPLIER_CREDIT: 'Supplier Credit',
};

export const STATUS_LABEL: Record<PurchaseStatus, string> = {
  DRAFT: 'Draft',
  PENDING_APPROVAL: 'Awaiting approval',
  APPROVED: 'Approved',
  POSTED: 'Posted',
  CLOSED: 'Closed',
  VOIDED: 'Voided',
};

export const STATUS_TONE = { DRAFT: 'neutral', PENDING_APPROVAL: 'warning', APPROVED: 'info', POSTED: 'ok', CLOSED: 'neutral', VOIDED: 'critical' } as const;

export const VAT_CLASS_LABEL: Record<InputVatClass, string> = {
  GOODS: 'Goods',
  CAPITAL: 'Capital goods',
  SERVICES: 'Services',
  IMPORTATION: 'Importation',
  NONE: 'Not claimable',
};

export interface PurchaseSummary {
  id: string;
  kind: PurchaseKind;
  status: PurchaseStatus;
  number: string | null;
  contactId: string;
  supplier?: string;
  branchId: string;
  supplierInvoiceNo: string;
  supplierInvoiceDate: string | null;
  date: string;
  dueDate: string | null;
  reference: string;
  netAmount: string;
  inputVat: string;
  nonCreditableVat: string;
  ewtAmount: string;
  totalAmount: string;
  payableAmount: string;
  balanceDue: string;
  ewtAtBooking: boolean;
  rowVersion: number;
}

export interface PurchaseLineView {
  id: string;
  lineNo: number;
  itemId: string | null;
  description: string;
  quantity: string;
  uom: string;
  unitPrice: string;
  discount: string;
  taxCode: string;
  inputVatClass: InputVatClass;
  accountId: string | null;
  atc: string | null;
  ewtBase: string;
  ewtAmount: string;
  netAmount: string;
  vatAmount: string;
  grossAmount: string;
}

export interface PurchaseDetail extends PurchaseSummary {
  notes: string;
  pricesIncludeVat: boolean;
  journalEntryId: string | null;
  createdById: string;
  approvedById: string | null;
  postedAt: string | null;
  voidReason: string | null;
  supplierView: { registeredName: string; tinFormatted: string | null; address: string; vatStatus: string };
  credits: { id: string; number: string | null; status: PurchaseStatus; totalAmount: string }[];
  derived: { id: string; kind: PurchaseKind; number: string | null; status: PurchaseStatus }[];
  source: { id: string; kind: PurchaseKind; number: string | null } | null;
  bill: { id: string; number: string | null; supplierInvoiceNo: string } | null;
  payments: { paymentId: string; number: string | null; date: string; amount: string; ewtAmount: string; status: string }[];
  lines: PurchaseLineView[];
  warnings?: string[];
}
